import React, { useEffect, useState } from "react";

import { XButtonBackground } from "../../assets";

import { useChannelStateContext, useChatContext } from "stream-chat-react";

import "./DisplayMembers.css";
import { Button, Drawer, Avatar, Box, Modal, Badge } from "@mui/material";
import { auth } from "../../api/firebase";

// redux - use
import { useNotification } from "../../redux/useNotification";

/* ───────── ミュート判定ユーティリティ ───────── */
const isChannelMuted = (client, channel) =>
  !!client?.mutedChannels?.some((m) => (m.channel?.cid ?? m.cid) === channel?.cid);

const UserResult = ({ user, channel }) => (
  <>
    <li
      className="messaging-create-channel__user-result"
      onClick={() => console.log(user.channel_role)}
    >
      <Avatar
        src={user.user.image}
        name={user.user.name || user.user.id}
        sx={{ width: 40, height: 40 }}
      />
      {user.user.online && (
        <div className="messaging-create-channel__user-result-online" />
      )}

      <div className="messaging-create-channel__user-result__details ">
        <span>{user.user.name}</span>
      </div>
    </li>
    <div>{user.role === "owner" && "管理者"}</div>
  </>
);

const DisplayMembers = ({ openMembers, toggleMembers }) => {
  // redux - Notification
  const { displayNotification } = useNotification();

  const { channel } = useChannelStateContext();
  const { client } = useChatContext();

  const [channelMember, setChannelMember] = useState([]);
  const [isMute, setIsMute] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // member取得
  useEffect(() => {
    const getChannelMembers = async () => {
      try {
        const sort = { created_at: -1 };
        const res = await channel.queryMembers({}, sort, {});
        setChannelMember(res?.members ?? []);
      } catch (e) {
        console.error("queryMembers failed:", e);
      }
    };
    if (channel) getChannelMembers();
  }, [channel]);

  // ミュート状態 初期化 + イベント追従
  useEffect(() => {
    if (!client || !channel) return;

    const refresh = () => setIsMute(isChannelMuted(client, channel));
    refresh();

    const sub = client.on((e) => {
      if (
        e.type === "channel.muted" ||
        e.type === "channel.unmuted" ||
        e.type === "notification.channel_mutes_updated" ||
        e.type === "notification.mutes_updated" ||
        e.type === "health.check"
      ) {
        refresh();
      }
    });
    return () => sub.unsubscribe();
  }, [client, channel?.cid]);

  // ミュート切替
  const handleMute = async () => {
    if (!channel) return;
    try {
      setIsLoading(true);
      if (isChannelMuted(client, channel)) {
        await channel.unmute();
      } else {
        await channel.mute();
      }
      setIsMute(isChannelMuted(client, channel)); // 即時反映
    } catch (e) {
      console.error("mute/unmute failed:", e);
    } finally {
      setIsLoading(false);
      handleClose(); // モーダル閉じ
    }
  };

  // Remove
  const handleRemove = async () => {
    try {
      const state = await channel.watch();
      if ((state?.members?.length ?? 0) <= 2) {
        displayNotification({
          message: "1:1のチャンネルの脱退はできません。ミュートを推奨します。",
          type: "error",
        });
        return;
      }
      await channel.removeMembers([auth.currentUser.uid]);
      // 画面更新は外部の state に任せる。必要なら軽い案内だけ
      displayNotification({ message: "チャンネルを離れました。", type: "success" });
      handleCloseRemove();
      toggleMembers();
    } catch (error) {
      displayNotification({
        message: "このチャンネルの、脱退権限がありません。",
        type: "error",
      });
      console.error(error);
    }
  };

  // Mute モーダル
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Remove モーダル
  const [openRemove, setOpenRemove] = useState(false);
  const handleOpenRemove = () => setOpenRemove(true);
  const handleCloseRemove = () => setOpenRemove(false);

  // AddAdmin モーダル
  const [openDialog, setOpenDialog] = useState(false);
  const [targetUser, setTargetUser] = useState();
  const handleClickOpenDialog = ({ user }) => {
    setOpenDialog(true);
    setTargetUser(user);
  };
  const handleDiaogClose = () => setOpenDialog(false);

  const handleAddAdmin = async () => {
    try {
      await channel.assignRoles([{ user_id: targetUser.id, channel_role: "owner" }]);
      displayNotification({ message: "管理者権限を付与しました。", type: "success" });
      handleDiaogClose();
    } catch (e) {
      console.error(e);
      displayNotification({ message: "権限付与に失敗しました。", type: "error" });
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const MuteComponent = () => (
    <Box sx={style}>
      <div className="rounded-md p-2 border text-center text-white bg-black ">
        チャンネルミュート
      </div>
      <div className="mt-2">このチャンネルのミュート設定を変更しますか？</div>
      <div className="flex mt-3">
        現在の設定：
        {isMute ? <div className="text-red-500">オン</div> : <div className="text-blue-500">オフ</div>}
      </div>
      <div className="text-xs text-gray-500 mt-3">
        ミュート設定がオンになっていると、このチャンネルが更新されたときの通知が来なくなります
      </div>
      <div className="flex justify-around mt-2">
        <Button
          variant="outlined"
          onClick={handleMute}
          color={!isMute ? "error" : "primary"}
          disabled={isLoading || !channel}
        >
          {isMute ? "オフ" : "オン"}
        </Button>
        <Button variant="outlined" onClick={handleClose} disabled={isLoading}>
          キャンセル
        </Button>
      </div>
    </Box>
  );

  const RemoveComponent = () => (
    <Box sx={style}>
      <div className="rounded-md p-2 border text-center text-white bg-black ">
        チャンネルを離れる
      </div>
      <div className="mt-2">このチャンネルを離れますか？</div>
      <div className="text-xs text-gray-500 mt-3">
        このチャンネルを離れると、残ったチャンネル内の誰かがメンバー追加してくれないと戻れません
      </div>
      <div className="flex justify-around mt-2">
        <Button variant="outlined" onClick={handleRemove} disabled={isLoading} color="error">
          離れる
        </Button>
        <Button variant="outlined" onClick={handleCloseRemove} disabled={isLoading}>
          キャンセル
        </Button>
      </div>
    </Box>
  );

  const AddAdminRole = () => (
    <Box sx={style}>
      <div className="rounded-md p-2 border text-center text-white bg-black ">
        管理者権限の付与
      </div>
      <div className="mt-2">{targetUser?.name} さんに管理者権限を付与しますか？</div>
      <div className="text-xs text-gray-500 mt-3">
        管理者権限を付与された人は、メンバーの追加・削除、チャンネルの削除などができるようになります
      </div>
      <div className="flex justify-around mt-2">
        <Button variant="outlined" onClick={handleAddAdmin} disabled={isLoading} color="error">
          はい
        </Button>
        <Button variant="outlined" onClick={handleDiaogClose} disabled={isLoading}>
          キャンセル
        </Button>
      </div>
    </Box>
  );

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <MuteComponent />
      </Modal>
      <Modal open={openRemove} onClose={handleCloseRemove}>
        <RemoveComponent />
      </Modal>
      <Modal open={openDialog} onClose={handleDiaogClose}>
        <AddAdminRole />
      </Modal>

      <Drawer anchor="left" open={openMembers} onClose={toggleMembers}>
        <div className="w-96 mt-20 p-2">
          {/* 閉じるボタン */}
          <div className="flex my-2 justify-end" onClick={toggleMembers}>
            <XButtonBackground />
          </div>

          <div className=" font-bold text-3xl">管理</div>

          <div className="flex flex-col space-y-2 my-2">
            {/* チャンネルを離れる */}
            <Button onClick={handleOpenRemove} variant="outlined" color="error">
              チャンネルを離れる
            </Button>

            {/* ミュート */}
            <Button onClick={handleOpen} variant="outlined" disabled={!channel}>
              {isMute ? "ミュートをやめる" : "このチャンネルをミュート"}
            </Button>
          </div>

          {/* メンバー一覧 */}
          <div className="font-bold text-3xl">Member</div>
          <div className="flex space-x-2">
            <div className="text-xs">メンバー：{channel?.data?.member_count ?? 0}</div>
            <div className="text-xs">オンライン：{channel?.state?.watcher_count ?? 0}</div>
          </div>
          {!!channelMember?.length && (
            <div>
              {channelMember.map((user, i) => (
                <div key={user.user.id} className="messaging-create-channel__user-result">
                  <UserResult user={user} channel={channel} />
                  {channel?.state?.members?.[auth.currentUser?.uid]?.role === "owner" && (
                    <div onClick={() => handleClickOpenDialog(user)}>管理者にする</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};

export default React.memo(DisplayMembers);
